/* eslint-disable */
import Header from "../component/Header/Header";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import React,{ useEffect, useState } from "react";
import FooterCommon from "../component/FooterCommon/FooterCommon";
export const ComponentWrapper = styled.div`
  &.with-toolbar {
    margin-top: 173px;
  }
  &.no-toolbar {
    margin-top: 123px;
  }
`;


export function withHeaderFooter(WrappedComponent) {
    
  return function (props) {
    return (
      <ComponentWrapper className={false ? "with-toolbar" : "no-toolbar"}>
        <Header withToolbar={false} />
        <WrappedComponent {...props} />
        {true && <FooterCommon />}
      </ComponentWrapper>
    );
  };
}
